jQuery(document).ready( function( $ ) {
    console.log('aa');



console.log(    $('.wp-list-table.services .edit'));
    $('.wp-list-table.services .edit').on( 'click', function() {
        console.log(this);
        console.log($(this));

        $('ul.subsubsub a').removeClass( 'current' );
    });
});



//////////////////
// WEBPACK FOOTER
// ./_src/admin/js/admin-edit.dev.js
// module id = 1
// module chunks = 5